import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import {CheckOutlined} from "@ant-design/icons-vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CheckSquare',
  props: {
    check: { type: Boolean }
  },
  emits: ['update:check'],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["check-square", {on:__props.check}]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:check', !__props.check)))
  }, [
    _renderSlot(_ctx.$slots, "default"),
    (__props.check)
      ? (_openBlock(), _createBlock(_unref(CheckOutlined), { key: 0 }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})